import { put } from "@redux-saga/core/effects";
import axios from "axios";

import { FormsService, GetUserFontsResponse } from "../../../services/forms";
import { getFormFailure, getUserFontsSuccess, setInitialFonts } from "../actionCreators";
import { IErrorType } from "../../types/errors.d";
import { formInitials } from "../../../helpers/dataManipulations/initials";

export function* getUserFontsSaga() {
    try {
        const {
            data: { data },
        }: GetUserFontsResponse = yield FormsService.getUserFonts();
        //TODO: After fixing fonts issues in  BACKEND  this condition will be removed
        if (data.length) {
            yield put(getUserFontsSuccess({ fonts: data }));
        } else {
            yield put(setInitialFonts({ fonts: formInitials.fonts }));
        }
    } catch (error) {
        if (axios.isAxiosError(error))
            yield put(getFormFailure({ errorType: IErrorType.AXIOS, data: error.response?.data }));
        else yield put(getFormFailure({ errorType: IErrorType.NATIVE, data: error }));
    }
}
